import _axios from "../../invoiceReq.js";
import qs from 'qs'

// 文档
// http://sc-docs.tsa.cn/document/swagger-ui/306.html#/InvoiceController/insertInvoice

//申请开票前获取验签
export const preInvoice = (data) =>
    _axios({
        url: '/invoice/v2/preInvoice',
        method: "post",
        data,
    });

//申请开票
export const addInvoice = (data) =>
    _axios({
        url: '/invoice/v2/addInvoice',
        method: "post",
        data,
    });

// 开票历史
export const searchAppInvoiceList = (params) =>
    _axios({
        url: '/invoice/v2/searchAppInvoiceList',
        method: "get",
        params,
    });

//重新发送
export const resendEmail = (data) =>
    _axios({
        url: '/invoice/resendEmail',
        method: "put",
        data,
    });

export const resendMessage = (data) =>
    _axios({
        url: '/invoice/v3/resendMessage/nvc',
        method: "put",
        data,
    });

//获取发票下载地址
export const getInvoiceUrl = (code) =>
    _axios({
        url: `/invoice/v2/getInvoiceUrl/${code}`,
        method: "get",
    });

//获取下载资源
export const downloadInvoiceUrl = (invoiceCode,type) =>
    _axios({
        url: `/invoice/v2/downloadInvoiceUrl/${invoiceCode}/${type}`,
        method: "get",
    });

//获取发票详情
export const getInvoiceDetailById = (id) =>
    _axios({
        url: `/invoice/v2/getInvoiceDetailById/${id}`,
        method: "get",
    });


//申请重开
export const reopen = (data) =>
    _axios({
        url: '/invoice/v2/reopen',
        method: "post",
        data,
    });
 
    
//申请重开
export const preReopen = (id) =>
    _axios({
        url: `/invoice/v2/preReopen/${id}`,
        method: "get",
    });

//发票抬头列表
export const getTitleList = (params) =>
    _axios({
        url: `/invoice/title/search`,
        method: "get",
        params
    });

//设置默认发票抬头
export const setDefaultTitle = (data) =>
    _axios({
        url: `/invoice/title/setDefault`,
        method: "put",
        data
    });

//取消默认发票抬头
export const cancelDefaultTitle = (data) =>
    _axios({
        url: `/invoice/title/cancelDefault`,
        method: "put",
        data
    });

//新增发票抬头
export const addTitle = (data) =>
    _axios({
        url: '/invoice/title/add',
        method: "post",
        data,
    });
    
//删除发票抬头
export const deleteTilte = (id) =>
    _axios({
        url: `/invoice/title/delete?id=${id}`,
        method: "delete",
    });

//编辑发票抬头
export const editeTitle = (data) =>
    _axios({
        url: `/invoice/title/edite`,
        method: "put",
        data
    });
    
//根据输入查询匹配企业
export const searchByName = (params) =>
    _axios({
        url: `/invoice/entInfo/searchByName`,
        method: "get",
        params,
        stopLoading:true,
        returnCatch:true
    });

//根据输企业查询税号
export const searchByCode = (params) =>
    _axios({
        url: `/invoice/entInfo/searchByCode`,
        method: "get",
        params,
        stopLoading:true
    });